
import React from 'react';
import Editor from './Editor';
import './App.css';

const App = () => (
  <div className="seditious">
    <header>seditious</header>
    <Editor/>
  </div>
);
export default App;



/** WEBPACK FOOTER **
 ** ./src/App.js
 **/